import { inject, Injectable } from '@angular/core';
import { Firestore, collection, doc, addDoc, updateDoc, deleteDoc, getDoc, collectionData, docData, query, where } from '@angular/fire/firestore';
import { BehaviorSubject, Observable } from 'rxjs';
import { User } from '../models/user';

@Injectable({
  providedIn: 'root'
})
export class ProfileService {
  private firestore = inject(Firestore)
  private usersCollection = collection(this.firestore, 'users');

  /**  Create a new user */
  async createUser(user: User): Promise<void> {
    const userData: User = {
      ...user,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString()
    };
    await addDoc(this.usersCollection, userData);
  }

  /**  Get all users (real-time updates) */
  getAllUsers(): Observable<User[]> {
    return collectionData(this.usersCollection, { idField: 'id' }) as Observable<User[]>;
  }

  /**  Get a single user by ID */
  getUserById(id: string): Observable<User | undefined> {
    const userDoc = doc(this.firestore, `users/${id}`);
    return docData(userDoc, { idField: 'id' }) as Observable<User | undefined>;
  }

  /**  Update user data */
  async updateUser(id: string, data: Partial<User>): Promise<void> {
    const userDoc = doc(this.firestore, `users/${id}`);
    await updateDoc(userDoc, {
      ...data,
      updatedAt: new Date().toISOString()
    });
  }

  /**  Delete user */
  async deleteUser(id: string): Promise<void> {
    const userDoc = doc(this.firestore, `users/${id}`);
    await deleteDoc(userDoc);
  }

  /**  Get users by role (Admin / Customer) */
  getUsersByRole(role: string): Observable<User[]> {
    const q = query(this.usersCollection, where('role', '==', role));
    return collectionData(q, { idField: 'id' }) as Observable<User[]>;
  }
}
